export default "__VITE_ASSET__C_UFcY9Z__"